import React from 'react';
import { postponeCosts } from '../data/postponeCosts';
import { Section, SectionHeader } from './Shared';
export function CostComparison() {
  return <Section id="postergar" tone="white" innerClassName="max-w-4xl" data-id="element-33" data-mp="2av67mygayd6c">
      <SectionHeader title="¿Cuánto tiempo se te va buscando una idea?" data-id="element-34" data-mp="26vxb5ltvo173" />

      <ul className="mt-10 overflow-hidden rounded-3xl border border-brand-violet/10" data-id="element-35" data-mp="21wazhgtp6t0e">
        {postponeCosts.map(row => <li key={row.situation} className={`grid gap-1 border-b border-brand-violet/10 px-5 py-4 last:border-b-0 md:grid-cols-[0.9fr_1.1fr] md:items-center md:gap-6 md:px-7 md:py-5 ${row.positive ? 'bg-brand-mint' : 'bg-white'}`} data-id="element-36" data-mp="2ymbjl2j4glbd">
            <span className="text-base font-bold text-brand-violet md:text-lg" data-id="element-37" data-mp="2pjiv171bqnp8">{row.situation}</span>
            <span className={`text-base leading-snug ${row.positive ? 'font-bold text-brand-violet' : 'text-brand-ink/80'}`} data-id="element-38" data-mp="2km0wmakxnqvh">
              <span aria-hidden="true" className="font-bold text-brand-orangeDark" data-id="element-39" data-mp="1973sruk3ax42">
                →{' '}
              </span>
              {row.consequence}
            </span>
          </li>)}
      </ul>

      <p className="mx-auto mt-10 max-w-2xl text-center font-display text-xl font-bold leading-snug text-brand-violet md:text-2xl" data-id="element-40" data-mp="2pce4qpf5sbdp">
        No hace falta crear un disfraz perfecto para compartir una tarde que valga la pena.
      </p>
    </Section>;
}